function getPathLength(element) {
  if (element == null) {
    return 0;
  }

  return element.getTotalLength();
}

export { getPathLength };
